import { b as I, d as M, k as _, f as p, h as C, j as L } from "./_getTag-4e44633b.mjs";
import { b as o } from "./_baseIsEqual-12d01a44.mjs";
import { b as P, c as w, t as h, a as O, i as y } from "./identity-6eafe87b.mjs";
import { a as R } from "./isArray-0d9c7aaa.mjs";
var D = 1, G = 2;
function x(n, r, i, e) {
  var t = i.length, u = t, s = !e;
  if (n == null)
    return !u;
  for (n = Object(n); t--; ) {
    var f = i[t];
    if (s && f[2] ? f[1] !== n[f[0]] : !(f[0] in n))
      return !1;
  }
  for (; ++t < u; ) {
    f = i[t];
    var l = f[0], a = n[l], A = f[1];
    if (s && f[2]) {
      if (a === void 0 && !(l in n))
        return !1;
    } else {
      var d = new I();
      if (e)
        var g = e(a, A, l, n, r, d);
      if (!(g === void 0 ? o(A, a, D | G, e, d) : g))
        return !1;
    }
  }
  return !0;
}
function m(n) {
  return n === n && !M(n);
}
function F(n) {
  for (var r = _(n), i = r.length; i--; ) {
    var e = r[i], t = n[e];
    r[i] = [e, t, m(t)];
  }
  return r;
}
function E(n, r) {
  return function(i) {
    return i == null ? !1 : i[n] === r && (r !== void 0 || n in Object(i));
  };
}
function v(n) {
  var r = F(n);
  return r.length == 1 && r[0][2] ? E(r[0][0], r[0][1]) : function(i) {
    return i === n || x(i, n, r);
  };
}
function S(n, r, i) {
  var e = n == null ? void 0 : P(n, r);
  return e === void 0 ? i : e;
}
function K(n, r) {
  return n != null && r in Object(n);
}
function N(n, r, i) {
  r = w(r, n);
  for (var e = -1, t = r.length, u = !1; ++e < t; ) {
    var s = h(r[e]);
    if (!(u = n != null && i(n, s)))
      break;
    n = n[s];
  }
  return u || ++e != t ? u : (t = n == null ? 0 : n.length, !!t && p(t) && C(s, t) && (R(n) || L(n)));
}
function T(n, r) {
  return n != null && N(n, r, K);
}
var U = 1, $ = 2;
function q(n, r) {
  return O(n) && m(r) ? E(h(n), r) : function(i) {
    var e = S(i, n);
    return e === void 0 && e === r ? T(i, n) : o(r, e, U | $);
  };
}
function H(n) {
  return function(r) {
    return r == null ? void 0 : r[n];
  };
}
function B(n) {
  return function(r) {
    return P(r, n);
  };
}
function J(n) {
  return O(n) ? H(h(n)) : B(n);
}
function Z(n) {
  return typeof n == "function" ? n : n == null ? y : typeof n == "object" ? R(n) ? q(n[0], n[1]) : v(n) : J(n);
}
export {
  Z as b
};
